import React from "react";

const WhyUs = () => {
    return (
        <div>
            <h4>Why choose us</h4>
        </div>
    );
};

export default WhyUs;
